import { lazyLoad } from "utils/loadable"

export const RidersPage = lazyLoad(
  () => import("./index"),
  module => module.RidersPage,
)
